import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import useBattleStyles from '../../styles/kozelBattle/battle';
import logoBattle from '../../assets/images/kozel_battle/logo_battle.png';
import sticlaBlonda from '../../assets/images/kozel_battle/sticla_blonda.png';
import sticlaBruna from '../../assets/images/kozel_battle/sticla_bruna.png';
import lightVsDark from '../../assets/images/kozel_battle/light_vs_dark2.png';
import Game from './Game';
import { useAppDispatch } from '../../stores/store';
import { generateKozelUserId } from '../../features/games/kozelBattleSlice';

const Battle: React.FC = () => {
  const classes = useBattleStyles();
  const dispatch = useAppDispatch();
  const [gameStarted, setGameStarted] = useState(false);

  const handleStartGame = async () => {
    const existingId = localStorage.getItem('kozelBattleUuid');
    if (!existingId) {
      try {
        await dispatch(generateKozelUserId()).unwrap();
      } catch {
        return;
      }
    }
    setGameStarted(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (gameStarted) {
    return (
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        backgroundColor: '#1a0a00',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Game onBack={() => setGameStarted(false)} />
      </Box>
    );
  }

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.content}>

        <img
          src={logoBattle}
          alt="Light Versus Dark Battle"
          className={classes.logoBattle}
        />

        <Typography className={classes.subtitle}>
          Alege berea KOZEL preferată și dă start jocului pentru a aduce
          puncte echipei tale!
        </Typography>

        <Box className={classes.mainLayout}>
          <Box className={classes.bottlesRow}>
            <Box className={classes.bottleGroup}>
              <Typography className={classes.teamLightLabel}>TEAM BLONDE</Typography>
              <Box className={classes.bottleBlondaWrapper}>
                <img src={sticlaBlonda} alt="Sticla Blonda" className={classes.bottleImage} />
              </Box>
            </Box>

            <Box className={classes.bottlesMiddleSpacer} />

            <Box className={classes.bottleGroup}>
              <Typography className={classes.teamDarkLabel}>TEAM DARK</Typography>
              <Box className={classes.bottleBrunaWrapper}>
                <img src={sticlaBruna} alt="Sticla Bruna" className={classes.bottleImage} />
              </Box>
            </Box>
          </Box>

          <img
            src={lightVsDark}
            alt="Light VS Dark"
            className={classes.lightVsDarkImage}
          />
        </Box>

        <button
          className={classes.startButton}
          onClick={handleStartGame}
        >
          START GAME
        </button>

      </Box>
    </Box>
  );
};

export default Battle;